import type { OpenMachineRequest } from '@couch/shared';
import { api, errorMessage } from '../../api/client';

/** Opens the tab synchronously (no popup blocker), then sends it to the one-time link — optionally with a recipe to load. */
export function openComfy(machineId: string, onError: (message: string) => void, request: OpenMachineRequest = {}): void {
  const tab = window.open('about:blank', '_blank');
  api.openMachine(machineId, request).then(({ url }) => {
    if (!tab) { window.location.assign(url); return; }
    tab.opener = null;
    tab.location.href = url;
  }, (error: unknown) => {
    tab?.close();
    onError(errorMessage(error));
  });
}
